import { ExternalLinkIcon, InfoIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { selectAccountSlug, selectBrainId } from '@/redux/session/selectors';

// Shared by ToolkitNodeIntent and ToolkitNodeEvent — shown in a node's
// sidebar when it's the brain's starting node.
export const StartingDialogBanner = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const slug = useSelector(selectAccountSlug);
  const brainId = useSelector(selectBrainId);

  return (
    <Alert variant="info" className="mt-6 gap-y-2 text-muted-foreground">
      <InfoIcon size={16} />
      <AlertTitle className="text-sm leading-5 font-semibold tracking-normal">
        {t('ai_agents.conversation_start.node_banner_title')}
      </AlertTitle>
      <AlertDescription>
        <div className="flex flex-col gap-2">
          <span>{t('ai_agents.conversation_start.node_banner_text')}</span>
          <button
            type="button"
            onClick={() => navigate(`/${slug}/ai-agents/${brainId}/settings#conversation-start`)}
            className="inline-flex items-center gap-1 self-start font-medium text-primary"
          >
            {t('ai_agents.conversation_start.configure')}
            <ExternalLinkIcon size={16} />
          </button>
        </div>
      </AlertDescription>
    </Alert>
  );
};
